/**
 * Broadcast event state changes to other tabs
 * When one tab changes event state (pause/start/close/etc), other tabs will refresh
 */

// Broadcast refresh signal to other tabs
export const broadcastEventRefresh = (eventIdx) => {
	if (typeof BroadcastChannel !== 'undefined') {
		const channel = new BroadcastChannel(`event-${eventIdx}-state`)
		channel.postMessage('refresh')
		channel.close()
	}
}

// Setup listener for refresh signals from other tabs
export const setupEventRefreshListener = (
	eventIdx,
	callback = () => window.location.reload()
) => {
	if (typeof BroadcastChannel !== 'undefined') {
		const channel = new BroadcastChannel(`event-${eventIdx}-state`)
		channel.onmessage = (event) => {
			if (event.data === 'refresh') {
				callback()
			}
		}
		return () => channel.close()
	}
	return () => {} // No-op cleanup for unsupported browsers
}
